import React, { Fragment, useEffect, useState } from 'react';
import { Redirect, useLocation, matchPath } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import ConfirmLogout from '../ConfirmLogout';
import { routes } from 'src/routes';

const AuthGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [confirmPop, setConfirmPop] = useState(false);

  const findComponentForRoute = (path, routes) => {
    const matchingRoute = routes.find((route) =>
      matchPath(path, {
        path: route.path,
        exact: route.exact
      })
    );

    if (matchingRoute && matchingRoute.routes) {
      return findComponentForRoute(path, matchingRoute.routes);
    }
    return matchingRoute && matchingRoute.guard
      ? confirmLogoutPopUp(matchingRoute.guard)
      : null;
  };

  const confirmLogoutPopUp = (guard) => {
    if (guard.name === 'GuestGuard') {
      setConfirmPop(true);
    }
  };

  useEffect(() => {
    if (location.state && location.state.from.pathname) {
      let path = location.state.from.pathname;
      findComponentForRoute(path, routes);
    }
  }, []);

  if (!isAuthenticated) {
    if (location.pathname) {
      let next = location.pathname.split('/').join('.');
      return <Redirect to={`/login?next=${next}`} />;
    }

    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      {children}
      {confirmPop ? (
        <ConfirmLogout confirmPop={confirmPop} setConfirmPop={setConfirmPop} />
      ) : undefined}
    </Fragment>
  );
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
